import { createAsyncThunk, createSlice, createSelector, createEntityAdapter } from '@reduxjs/toolkit';
import http from '../../lib/http';
import * as types from '../../edilia/types';
import { getIndiceAt, nominal2CAC, CAC2nominal, VPresenteCAC, nextMonth, getInfoContrato, getInfoContratos } from '../../edilia/index';


export const getData = createAsyncThunk('GET_CONTRATOS', async (payload, thunkAPI) => {
  // return getInfoContratos({
  //   contratos : (await http.TABLE('/contratos')).body,
  //   titularidades : (await http.TABLE('/titularidadcontratos')).body,
  //   indices : (await http.TABLE('/indices')).body,
  //   clasesContrato : (await http.TABLE('/clasesContrato')).body,
  //   pagos : (await http.TABLE('/pagos')).body,
  //   personas : (await http.TABLE('/personas')).body,
  // });
  let started = Date.now();
});

export const altaContrato = createAsyncThunk('POST_CONTRATO', async (payload, thunkAPI) => {
  let a = {
    contratro: {},
    titulares: [],
    campanas: [],
  }
  let res = await http.POST('/contratos', payload);
  thunkAPI.dispatch(getData());
  return res;
});

export const editContrato = createAsyncThunk('EDIT_CONTRATO', async (payload, thunkAPI) => {
  let res = await http.PATCH('/contratos', payload);
  thunkAPI.dispatch(getData());
  return res;
});

export const getHistoriaFunc = createAsyncThunk('GET_HISTORIA_FUNC_CONTRATOS', async (payload, thunkAPI) => {
  let res = await http.GET('/funchistoriacontrato');
  return res.ok ? res.body : null;
});

export const getTiposCampana = createAsyncThunk('GET_TIPOS_CAMPANAS_CONTRATOS', async (payload, thunkAPI) => {
  let res = await http.GET('/tiposcampana');
  return res.ok ? res.body : null;
});

const initialState = {
  fetching: 0,
  error: null,
  message: null,
  data: {},
  historiaFunc: null,
  tiposCampana: null
};

const contratosSlice = createSlice({
  name: 'contratos',
  initialState,
  reducers: {
    cleanError: (state, action) => ({ ...state, error: null }),
    cleanMessage: (state, action) => ({ ...state, message: null }),
  },
  extraReducers: {
    [getData.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
    [getData.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: action  }),
    [getData.fulfilled]: (state, action) => ({ ...state, data: action.payload, fetching: state.fetching - 1 }),

    [altaContrato.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
    [altaContrato.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo dar alta Contrato!" }),
    [altaContrato.fulfilled]: (state, action) => ({
      ...state,
      fetching: state.fetching - 1,
      message: action.payload.status === 200 ? "Contrato agregado!" : null,
      error: action.payload.status != 200 ? "No se pudo dar alta Contrato!" : null,
    }),

    [editContrato.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
    [editContrato.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo editar el contrato!" }),
    [editContrato.fulfilled]: (state, action) => ({
      ...state,
      fetching: state.fetching - 1,
      message: action.payload.status === 200 ? "Contrato editado!" : null,
      error: action.payload.status != 200 ? "No se pudo editar el contrato!" : null,
    }),

    [getHistoriaFunc.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
    [getHistoriaFunc.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: action  }),
    [getHistoriaFunc.fulfilled]: (state, action) => ({ ...state, funcHistoria: action.payload, fetching: state.fetching - 1, error: "No se pudo obtener la funcion historia!" }),

    [getTiposCampana.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
    [getTiposCampana.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: action  }),
    [getTiposCampana.fulfilled]: (state, action) => ({ ...state, tiposCampana: action.payload, fetching: state.fetching - 1, error: "No se pudo obtener los tipos de campanas!" }),

  },
})

export const { cleanError, cleanMessage } = contratosSlice.actions
export default contratosSlice.reducer;